var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v("Parts Sold")])]),(_vm.loading)?_c('TableCardLoader'):_c('div',[(_vm.partSold.length > 0)?_c('PartSoldList',{attrs:{"items":_vm.partSold}}):_c('CCardBody',[_c('p',[_vm._v(" There are no parts sold found for "),_c('em',[_vm._v("MR #"+_vm._s(_vm.record.id))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }